import type {
    PillarPaymentRequestTypeMap,
    PillarProcessCardTokenPaymentRequest,
    PillarTerminalSaleRequest,
    ProcessCardTokenPaymentRequest,
    TerminalSaleRequest,
    TransactionDetails,
} from '../../../payment.types';

export const CloverSidebarPaymentEntryActionType = {
    TERMINAL_SALE: 'terminal_sale',
    TOKEN_SALE: 'token_sale',
    STORED_TOKEN_SALE: 'stored_token_sale',
    ACH_PAYMENT: 'ach_payment',
} as const;

export type CloverSidebarPaymentEntryActionType =
    (typeof CloverSidebarPaymentEntryActionType)[keyof typeof CloverSidebarPaymentEntryActionType];

export const CloverSidebarPaymentEntryOutcome = {
    BUILT: 'built',
    UNSUPPORTED_ACTION: 'unsupported_action',
} as const;

export type CloverSidebarPaymentEntryOutcome =
    (typeof CloverSidebarPaymentEntryOutcome)[keyof typeof CloverSidebarPaymentEntryOutcome];

export interface CloverTerminalSaleSidebarPaymentEntryAction {
    readonly actionType: typeof CloverSidebarPaymentEntryActionType.TERMINAL_SALE;
    readonly request: TerminalSaleRequest;
}

export interface CloverTokenSaleSidebarPaymentEntryAction {
    readonly actionType: typeof CloverSidebarPaymentEntryActionType.TOKEN_SALE;
    readonly request: ProcessCardTokenPaymentRequest;
}

export interface CloverStoredTokenSaleSidebarPaymentEntryAction {
    readonly actionType: typeof CloverSidebarPaymentEntryActionType.STORED_TOKEN_SALE;
    readonly request: ProcessCardTokenPaymentRequest;
}

export interface CloverUnsupportedSidebarPaymentEntryAction {
    readonly actionType: typeof CloverSidebarPaymentEntryActionType.ACH_PAYMENT;
}

export type CloverSupportedSidebarPaymentEntryAction =
    | CloverTerminalSaleSidebarPaymentEntryAction
    | CloverTokenSaleSidebarPaymentEntryAction
    | CloverStoredTokenSaleSidebarPaymentEntryAction;

export type CloverSidebarPaymentEntryAction =
    | CloverSupportedSidebarPaymentEntryAction
    | CloverUnsupportedSidebarPaymentEntryAction;

export interface CloverSidebarPaymentEntryRequestDetails {
    readonly action: CloverSidebarPaymentEntryAction;
}

export type CloverSidebarPaymentEntryRequest =
    | PillarTerminalSaleRequest
    | PillarProcessCardTokenPaymentRequest;

export type CloverSidebarPaymentEntryRequestType =
    | PillarPaymentRequestTypeMap['TERMINAL_SALE']
    | PillarPaymentRequestTypeMap['PROCESS_CARD_TOKEN_PAYMENT'];

export interface CloverSidebarPaymentEntryNormalizedResult {
    readonly actionType: CloverSidebarPaymentEntryActionType;
    readonly requestType: CloverSidebarPaymentEntryRequestType;
    readonly transactionDetails: TransactionDetails;
}

export type CloverSidebarPaymentEntryResponseDetails =
    | {
          readonly outcome: typeof CloverSidebarPaymentEntryOutcome.BUILT;
          readonly paymentRequest: CloverSidebarPaymentEntryRequest;
          readonly normalizedResult: CloverSidebarPaymentEntryNormalizedResult;
      }
    | {
          readonly outcome: typeof CloverSidebarPaymentEntryOutcome.UNSUPPORTED_ACTION;
          readonly actionType: typeof CloverSidebarPaymentEntryActionType.ACH_PAYMENT;
          readonly message: string;
      };
